<div class="modal-container">
  <div class="dialog-header mt-2">
    <div
      class="m-0 header-title"
      [ngClass]="{'with-close-button': !resumable}"
      data-cy="header"
      mat-dialog-title
    >{{title}}
    </div>
    <button
      *ngIf="!resumable"
      data-cy="dismis"
      mat-mini-fab
      color="primary"
      class="btn-close"
      mat-dialog-close
    >&times;</button>
  </div>
  <div class="counter-wrapper">
    <div class="current">
      <p>{{countdownClock.counter | irpTimer}}</p>
    </div>
    <round-progress
      [current]="countdownClock.current"
      [max]="countdownClock.from"
      color="#29AFE6"
      background="#f7f8f9"
      [radius]="125"
      [stroke]="15"
      [duration]="800"
      [animation]="'easeInOutQuart'"
      [animationDelay]="0"
    ></round-progress>
    <div class="row btn-group m-0 justify-content-center">
      <button
        *ngIf="resumable"
        mat-flat-button
        color="primary"
        data-cy="logout-warning--modal-resume-button"
        class="btn-rounded btn-xlarge submit-button m-center"
        (click)="close()"
      >Resume</button>
      <div
        class="banner-message"
        *ngIf="!resumable"
      >{{subtitle}}</div>
    </div>

  </div>

</div>
